<template>
  <div class="container-fluid mt-4" dir="rtl">

    <!-- أدوات التحكم (تختفي عند الطباعة) -->
    <div class="d-flex justify-content-between align-items-center mb-4 no-print">
      <div>
        <h4 class="fw-bold text-dark">
          <i class="fas fa-file-invoice-dollar ms-2"></i> التقرير الختامي (مالي / فني)
        </h4>
      </div>
      <div class="d-flex gap-2">
        <div class="input-group">
            <input v-model="search" @input="fetchData" type="text" class="form-control" placeholder="بحث...">
        </div>
        <button @click="printPage" class="btn btn-dark px-4">
          <i class="fas fa-print ms-2"></i> طباعة
        </button>
        <!-- زر تصدير إكسيل (اختياري) -->
        <button @click="exportExcel" class="btn btn-success px-4">
          <i class="fas fa-file-excel ms-2"></i> إكسيل
        </button>
      </div>
    </div>

    <!-- منطقة التقرير للطباعة -->
    <div class="card border-0 shadow-none" id="printSection">
      
      <!-- ترويسة التقرير الرسمية -->
      <div class="report-header d-none d-print-block mb-4 text-center">
        <div class="row align-items-center">
            <div class="col-4 text-end">
                <h6 class="fw-bold mb-1">محافظة ....................</h6>
                <h6 class="fw-bold mb-1">مديرية التربية والتعليم</h6>
                <h6 class="fw-bold">لجنة النظام والمراقبة</h6>
            </div>
            <div class="col-4">
                <h3 class="fw-bold text-decoration-underline py-2">كشف تظلمات الطلاب</h3>
                <h6 class="fw-bold">الشهادة الإعدادية - الدور الأول 2026</h6>
            </div>
            <div class="col-4 text-start">
                <h6 class="fw-bold">تحريراً في: {{ currentDate }}</h6>
                <h6 class="fw-bold">رقم الكشف: ( ..... )</h6>
            </div>
        </div>
        <hr class="border-dark border-2 opacity-100">
      </div>
<!-- استبدل قسم الـ table القديم بهذا الكود -->

<div class="table-responsive">
  <table class="table table-bordered border-dark text-center align-middle mb-0 custom-table">
    <thead class="bg-light text-dark">
      <tr>
        <th width="5%">م</th>
        <th width="10%">الرقم السري</th>
        <th width="10%">رقم الجلوس</th>
        <th width="15%">اسم الطالب</th>
        <th width="40%">تفاصيل المواد والدرجات</th> <!-- زاد العرض هنا ليستوعب البيانات -->
        <th width="10%">القسيمة</th>
        <th width="10%">المبلغ</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in reports" :key="row.id">
        <td>{{ index + 1 }}</td>
        
        <td class="fw-bold">{{ row.SecretKey || '---' }}</td>
        <td class="fw-bold fs-5">{{ row.Seating_No }}</td>
        <td class="text-start fw-bold">{{ row.student_name }}</td>
        
        <!-- ================================================= -->
        <!-- التعديل الجوهري: الجدول الداخلي للمواد والدرجات -->
        <!-- ================================================= -->
        <td class="p-0">
          <table class="table table-sm table-borderless mb-0 small-table w-100">
              <thead class="border-bottom bg-light text-muted" style="font-size: 0.8rem;">
                  <tr>
                      <th class="text-start pe-3" width="35%">المادة</th>
                      <th width="15%">قديمة</th>
                      <th width="15%">جديدة</th>
                      <th width="35%">حالة التظلم</th>
                  </tr>
              </thead>
              <tbody>
                  <tr v-for="sub in row.subjects" :key="sub.id">
                      <!-- اسم المادة -->
                      <td class="text-start pe-3 fw-bold">{{ sub.subject_name }}</td>
                      
                      <!-- الدرجة القديمة -->
                      <td class="text-muted">{{ sub.old_degree }}</td>
                      
                      <!-- الدرجة الجديدة (مميزة إذا تغيرت) -->
                      <td>
                          <span v-if="sub.new_degree" class="fw-bold text-success border-bottom border-success">
                              {{ sub.new_degree }}
                          </span>
                          <span v-else class="text-muted">-</span>
                      </td>

                      <!-- الحالة -->
                      <td class="text-center ps-2">
                          <span v-if="sub.new_degree && sub.new_degree > sub.old_degree" class="badge-print is-change">
                              <i class="fas fa-arrow-up"></i> تم التعديل
                          </span>
                          <span v-else-if="sub.has_remarks" class="badge-print is-yes">
                              <i class="fas fa-check"></i> له ملاحظات
                          </span>
                          <span v-else class="badge-print is-no">
                              لا يوجد
                          </span>
                      </td>
                  </tr>
              </tbody>
          </table>
        </td>
        <!-- ================================================= -->

        <td class="fw-bold font-monospace">{{ row.receipt_no || '---' }}</td>
        <td class="fw-bold">{{ row.total_amount }}</td>
      </tr>
    </tbody>
    
    <tfoot class="table-light fw-bold">
      <tr>
          <td colspan="6" class="text-end pe-3 fs-5">الإجمالي الكلي</td>
          <td class="fs-5 bg-warning-subtle">{{ totalAmount }} ج.م</td>
      </tr>
    </tfoot>
  </table>
</div>
      <!-- التوقيعات -->
      <div class="report-footer mt-5 pt-4 d-none d-print-block">
        <div class="row text-center">
            <div class="col-3">
                <p class="fw-bold mb-4">المختص المالي</p>
                <p>....................</p>
            </div>
            <div class="col-3">
                <p class="fw-bold mb-4">المراجع</p>
                <p>....................</p>
            </div>
            <div class="col-3">
                <p class="fw-bold mb-4">وكيل الكنترول</p>
                <p>....................</p>
            </div>
            <div class="col-3">
                <p class="fw-bold mb-4">رئيس اللجنة</p>
                <p>....................</p>
            </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import api from '@/api/axios';

export default {
  name: "FinalAdminReport",
  data() {
    return {
      reports: [],
      search: '',
      currentDate: new Date().toLocaleDateString('ar-EG'),
    };
  },
  computed: {
    // حساب إجمالي المبالغ تلقائياً
    totalAmount() {
        return this.reports.reduce((sum, item) => sum + Number(item.total_amount || 0), 0);
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const res = await api.get('/appeals/final-report', {
            params: { search: this.search }
        });
        this.reports = res.data;
      } catch (e) {
        console.error(e);
      }
    },
    printPage() {
        window.print();
    },
    exportExcel() {
        alert("يتم الآن تجهيز ملف الإكسيل...");
        //window.location.href = "/api/appeals/export-final";
    }
  }
};
</script>

<style scoped>
/* تنسيق الجدول الداخلي للمواد */
.small-table td {
    padding: 2px 5px !important;
    font-size: 0.9rem;
    border-bottom: 1px dashed #ccc !important;
}
.small-table tr:last-child td {
    border-bottom: none !important;
}

/* تنسيق البادج في الطباعة */
.badge-print {
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 0.8rem;
    display: inline-block;
}
.badge-print.is-yes {
    border: 1px solid #000;
    background-color: #e0e0e0; /* رمادي خفيف للطباعة */
    font-weight: bold;
}
.badge-print.is-no {
    color: #666;
}

/* --- تنسيقات الطباعة الصارمة --- */
@media print {
    @page {
        size: A4 portrait; /* أو landscape إذا كان الجدول عريضاً */
        margin: 10mm;
    }
    
    .no-print { display: none !important; }
    
    body { 
        background-color: white; 
        font-family: 'Times New Roman', serif; /* خط رسمي للطباعة */
    }

    .card { border: none !important; }

    /* جدول بخطوط سوداء واضحة */
    .custom-table, .custom-table th, .custom-table td {
        border: 1px solid black !important;
        font-size: 12pt;
    }
    
    .bg-light, .bg-warning-subtle {
        background-color: #f0f0f0 !important; /* لون رمادي للطباعة */
        -webkit-print-color-adjust: exact;
    }

    /* إخفاء الروابط والأيقونات الملونة */
    a { text-decoration: none; color: black; }
    .fas { display: none; } /* إخفاء الأيقونات في الطباعة لجعلها رسمية */
    
    /* إظهار علامة الصح فقط كنص */
    .is-yes .fas { display: inline-block !important; }
}
</style>